import { Stack, TitleGroup } from '@ekhodealer/ekho-common/rev';

import { BusinessDetailsForms } from '../business-details-forms/BusinessDetailsForms';

import { onboardingContent, OnboardingPage } from './content';

export function BusinessDetailsPage() {
	const pageContent = onboardingContent[OnboardingPage.BusinessDetails];

	return (
		<Stack itemsSpacing='24'>
			<TitleGroup
				title={pageContent.pageTitle}
				description={pageContent.subtitle}
				level='page'
				variant='centered'
				maxWidth='640px'
			/>
			<BusinessDetailsForms />
		</Stack>
	);
}
